import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { Column, TotalItem, Summary, GroupItem, Grouping } from "devextreme-react/data-grid";
import DateBox from 'devextreme-react/date-box';
import { PaginaCreacionLibre } from "../../Componentes/Compuestos/Paginas/PaginaCreacionLibre";
import { LVGridCabeceraReporte } from "../../Componentes/Basicos/LVGridCabeceraReporte";
import { CheckBox } from "devextreme-react";
import LVButtonReporte from "../../Componentes/Basicos/LVButtonReporte";
import { function_STK_ART_Stock_ListarValorizado } from "neftis7_apicaller/src/funciones/STK/STK_ART_Stock";
import ComboVenListaPreciosCabecera from "../../Componentes/Compuestos/Combos/ComboVenListaPreciosCabecera";

export const STK_ART_StockValorizado = () => {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState([])
  const [codigoListaPrecios, setCodigoListaPrecios] = useState("")
  const [globalUsaArticulosConPresentacion, setGlobalUsaArticulosConPresentacion] = useState([])
  const [globalUsaArticulosConTamano, setGlobalUsaArticulosConTamano] = useState([])
  const [globalUsaArticulosConUnidadDeMedida, setGlobalUsaArticulosConUnidadDeMedida] = useState([])
  const { VariablesGenerales: { DiasParaDesdeListados, DiasParaHastaListados } } = require('neftis7_apicaller');
  const { Varios: { ObtieneParametros, TratamientoDeVariableBoolean } } = require('neftis7_apicaller');

  const getData = async () => {
    // Llama a función asíncrona y maneja los datos
    try {

      const resultData = await function_STK_ART_Stock_ListarValorizado(codigoListaPrecios);

      setData(resultData.data)

    } catch (error) {
      alert("Error al obtener los datos: " + error);
    }
    setLoading(false)
  };

  const getDataParametros = async () => {// Llama a función asíncrona y maneja los datos
    try {
      const datosModificadores = await ObtieneParametros();
      const globalUsaArticulosConPresentacionLocal = await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConPresentacion)
      const globalUsaArticulosConTamanoLocal = await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConTamano)
      const globalUsaArticulosConUnidadDeMedidaLocal = await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConUnidadDeMedida)

      setGlobalUsaArticulosConPresentacion(globalUsaArticulosConPresentacionLocal)
      setGlobalUsaArticulosConTamano(globalUsaArticulosConTamanoLocal)
      setGlobalUsaArticulosConUnidadDeMedida(globalUsaArticulosConUnidadDeMedidaLocal)

    } catch (error) {
      alert("Error al obtener los datos: " + error);
    }
  };

  useEffect(() => {
    const user = localStorage.getItem("user");
    const codigoCompania = localStorage.getItem("CodigoCompania");
    const codigoEmpresa = localStorage.getItem("CodigoEmpresa");
    const codigoPlanta = localStorage.getItem("CodigoPlanta");
    const idPersona = localStorage.getItem("IdPersona");

    // Verificar valores en localStorage
    if (!user || !codigoCompania || !codigoEmpresa || !codigoPlanta || Number(idPersona) < 1) {
      if (Number(idPersona) === -1 || Number(idPersona) === -2 || Number(idPersona) === -3) {
      } else {
        return <Navigate to={"/Login"} />;
      }
    }

    getDataParametros();

    getData();
  }, []);

  return (
    <PaginaCreacionLibre
      Titulo="STOCK"
    >
      {loading ? (
        <div className="card-body text-center">
          <div className="spinner-border" role="status">
            <span className="sr-only">Cargando...</span>
          </div>
        </div>
      ) : (
        <div className="card-body">

          <table >
            <tbody>
              <tr>
                <td>
                  <ComboVenListaPreciosCabecera
                    onValueChanged={(e) => {
                      setCodigoListaPrecios(e.value);
                      getData();
                    }} value={codigoListaPrecios} ancho="290" />
                </td>
              </tr>
            </tbody>
          </table>
          <div className="table-responsive">
            {data.length > 0 ? (
              <LVGridCabeceraReporte
                dataSource={data}
                id="gridContainer"
                keyExpr="CodigoArticulo"
              >
                <Grouping autoExpandAll={true} />
                <Summary>
                  <TotalItem
                    column="CodigoArticulo"
                    summaryType="count"
                    customizeText={summaryItem => `Registros: ${summaryItem.value}`} />

                  <TotalItem
                    column="CantidadCompraValorizadaSinIVA"
                    summaryType="sum"
                    customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                    valueFormat="currency" />

                  <TotalItem
                    column="CantidadVentaValorizada"
                    summaryType="sum"
                    customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                    valueFormat="currency" />

                  <TotalItem
                    column="CantidadVentaValorizadaSinIVA"
                    summaryType="sum"
                    customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                    valueFormat="currency" />                                                                                           
                </Summary>

                <Column caption="Artículo" alignment="Center">
                  <Column caption="Código" dataField="CodigoArticulo" width="120" alignment="Left" dataType="string" />
                  <Column caption="Descripción" dataField="Articulo" width="100%" minWidth={200} alignment="Left" dataType="string" />
                </Column>
                <Column caption="Presentación" alignment="Center" visible={globalUsaArticulosConPresentacion}>
                  <Column caption="Código" dataField="CodigoPresentacion" width="100" alignment="Left" dataType="string" visible={globalUsaArticulosConPresentacion} />
                  <Column caption="Descripción" dataField="Presentacion" width="100" alignment="Left" dataType="string" visible={globalUsaArticulosConPresentacion} />
                </Column>
                <Column caption="Tamaño" alignment="Center" visible={globalUsaArticulosConTamano} >
                  <Column caption="Código" dataField="CodigoTamano" width="100" alignment="Left" dataType="string" visible={globalUsaArticulosConTamano} />
                  <Column caption="Descripción" dataField="Tamano" width="100" alignment="Left" dataType="string" visible={globalUsaArticulosConTamano} />
                </Column>
                <Column caption="Unidad de Medida" alignment="Center" visible={globalUsaArticulosConUnidadDeMedida} >
                  <Column caption="Código" dataField="CodigoUnidadMedida" width="100" alignment="Left" dataType="string" visible={globalUsaArticulosConUnidadDeMedida} />
                  <Column caption="Descripción" dataField="UnidadMedida" width="100" alignment="Left" dataType="string" visible={globalUsaArticulosConUnidadDeMedida} />
                </Column>
                <Column caption="Ubicación" alignment="Center" visible={globalUsaArticulosConUnidadDeMedida} >
                  <Column caption="Código" dataField="CodigoUbicacion" width="100" alignment="Left" dataType="string" visible={globalUsaArticulosConUnidadDeMedida} />
                  <Column caption="Descripción" dataField="Ubicacion" width="200" alignment="Left" dataType="string" visible={globalUsaArticulosConUnidadDeMedida} />
                </Column>

                <Column caption="Cantidad" dataField="CantidadActual" width="100" alignment="Right" dataType="number" />

                <Column caption="Importes Compra" alignment="Center">
                  <Column caption="Neto" dataField="ImporteCompraNeto" width="80" alignment="Right" dataType="number" format="currency" />
                  <Column caption="Total sin I.V.A." dataField="CantidadCompraValorizadaSinIVA" width="150" alignment="Right" dataType="number" format="currency" />
                </Column>
                <Column caption="Importes Venta" alignment="Center">
                  <Column caption="Neto" dataField="ImporteVentaNeto" width="80" alignment="Right" dataType="number" format="currency" />
                  <Column caption="I.V.A." dataField="ImporteVentaIVA" width="80" alignment="Right" dataType="number" format="currency" />
                  <Column caption="Total con I.V.A." dataField="CantidadVentaValorizada" width="150" alignment="Right" dataType="number" format="currency" />
                  <Column caption="Total sin I.V.A." dataField="CantidadVentaValorizadaSinIVA" width="150" alignment="Right" dataType="number" format="currency" />
                </Column>
              </LVGridCabeceraReporte>
            ) : (
              <div className="card-body text-center">
                <h5 className="card-title">No hay datos</h5>
              </div>
            )}
          </div>
        </div>
      )}
    </PaginaCreacionLibre>
  );
};
